export default __webpack_public_path__ + "static/media/van.1a1c9dcf.jpg";